import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  Card
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import request from "../../../utils/request";

import {
  updateEndorsementFormData,
  updateEndorsementScreenNumber
} from "src/features/rfqDataSlice";

/* Sections */
import EndorsementHeader from "./sections/EndorsementHeader";
import CustomerChangesTable from "./sections/CustomerChangesTable";
import DynamicFormChanges from "./sections/DynamicFormChanges";
import SumInsuredChanges from "./sections/SumInsuredChanges";
import EndorsementFooter from "./sections/EndorsementFooter";
import QcEndorsementView from "../QcEndorsementView";
import RiskDescriptionSection from "./sections/RiskDescriptionSection";
import ClausesCoverageChanges from "./sections/ClausesCoverageChanges";
import HypothecationChangeDetails from "./sections/HypothecationChangeDetails";
import SuggestedDeductibleSection from "./sections/SuggestedDeductibleSection";
import WarrantiesExclusionsChanges from "./sections/WarrantiesExclusionsChanges";
import EndorsementMailPreview from "./EndorsementMailPreview";

const EndorsementView = ({ onClose, endoresementEditDatas }) => {
  const dispatch = useDispatch();
  const componentRef = useRef<HTMLDivElement>(null);

  const [policyDetailsData, setPolicyDetailData] = useState<any[]>([]);

  const printForm = useReactToPrint({
    content: () => componentRef.current
  });

  useEffect(() => {
    dispatch(updateEndorsementScreenNumber(3));
    if (endoresementEditDatas?.policyId) {
      getPolicyDetailData();
    }
  }, []);

  useEffect(() => {
    if (endoresementEditDatas?.endorsementData) {
      dispatch(
        updateEndorsementFormData({
          ...endoresementEditDatas.endorsementData
        })
      );
    }
  }, [endoresementEditDatas]);

  if (!endoresementEditDatas) return null;

  const endorsementChanges =
    endoresementEditDatas?.endorsementChangeData || {};

  const getPolicyDetailData = () => {
    request({
      url: "insurancePolicy/getPolicyById",
      method: "post",
      data: {
        policyId: endoresementEditDatas?.policyId
      }
    }).then(
      (response) => {
        setPolicyDetailData(response?.data || []);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  return (
    <Dialog fullScreen open onClose={onClose}>
      {/* ================= APP BAR ================= */}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>

          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            Endorsement View
          </Typography>

          <IconButton
            color="inherit"
            aria-label="print"
            onClick={printForm}
          >
            <PrintIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* ================= CONTENT ================= */}
      <DialogContent
        ref={componentRef}
        sx={{
          padding: 0,
          backgroundColor: "#f5f5f5",
          display: "flex",
          justifyContent: "center"
        }}
      >
        {/* OUTER FULL WIDTH CONTAINER */}
        <div
          style={{
            width: "100%",
            padding: "16px",
            boxSizing: "border-box"
          }}
        >
          {/* INNER PRINT CONTAINER */}
          <div
            style={{
              width: "100%",
            //  maxWidth: "210mm",
              margin: "0 auto",
              background: "#fff"
            }}
          >
            <Card
              sx={{
                width: "100%",
                padding: 2,
                boxSizing: "border-box"
              }}
            >
              {endoresementEditDatas?.type !== "QC" ? (
                <>
                <EndorsementMailPreview selectedEndorsement={endoresementEditDatas}/>
                  {/* <EndorsementHeader
                    endorsement={endoresementEditDatas}
                    policyDetailsData={policyDetailsData}
                  />

                  <CustomerChangesTable
                    changes={endorsementChanges?.customerData}
                  />

                  <DynamicFormChanges
                    forms={endorsementChanges?.dynamicFormData}
                  />
                  <DynamicFormChanges
                    forms={endorsementChanges?.secondDynamicFormData}
                  />
                  <DynamicFormChanges
                    forms={endorsementChanges?.thirdDynamicFormData}
                  />

                  <SumInsuredChanges
                    sumInsuredChanges={
                      endorsementChanges?.sumInsuredData?.changes
                    }
                    excelChanges={endoresementEditDatas?.sumInsuredSectionData}
                  />
                  <RiskDescriptionSection data={endorsementChanges} />
                  <ClausesCoverageChanges data={endorsementChanges} />
                  <HypothecationChangeDetails data={endorsementChanges?.hypothetical_details} />
                  <SuggestedDeductibleSection data={endorsementChanges} />
                  <WarrantiesExclusionsChanges data={endorsementChanges} />

                  <EndorsementFooter
                    userInfo={endoresementEditDatas?.createdBy}
                  /> */}
                </>
              ) : (
                <QcEndorsementView
                  endoresementData={endoresementEditDatas}
                />
              )}
            </Card>
          </div>
        </div>
      </DialogContent>

    </Dialog>
  );
};

export default EndorsementView;
